<template>
  <div>
    <v-btn @click.stop="dialog = true"
           icon
    >
      <v-icon>mdi-pencil</v-icon>
    </v-btn>
    <v-dialog v-model="dialog"
              max-width="500"
              persistent
    >
      <SurroundChannelMappingForm
        v-if="dialog"
        :surroundChannelMappings="surroundChannelMappings"
        :channelCount="channelCount"
        :mapping="mapping"
        :title="'Save Surround Channel Mapping'"
        :clickAction="updateSurroundChannelMapping"
        :disableChannelCountEdit="true"
        @cancel="dialog = false"
      ></SurroundChannelMappingForm>
    </v-dialog>
  </div>
</template>

<script>
import SurroundChannelMappingForm from "./SurroundChannelMappingForm";
import { HubConnection } from "@microsoft/signalr";

export default {
  name:       "EditSurroundChannelMapping",
  components: { SurroundChannelMappingForm },
  props:      {
    connection:              HubConnection,
    surroundChannelMappings: Object,
    channelCount:            Number,
    mapping:                 Object,
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    updateSurroundChannelMapping(channelCount, mapping) {
      this.connection
        .invoke("UpdateSurroundChannelMapping", channelCount, mapping)
        .then((response) => {
          if (response.resultKind === "Success") {
            this.$emit("surround-mappings-updated", response.entity);
            this.dialog = false;
          } else {
            this.$emit("failure", response.reason);
          }
        })
        .catch((response) => {
          this.$emit("failure", response);
        });
    },
  },
};
</script>

<style scoped></style>
